import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { ReactComponent as CrossLargeIcon } from 'assets/icons/CrossLarge.svg';
import { ROUTE_DISCOVER } from 'routes';
import { COLORS } from 'styles/constants';
import useTheme from 'helpers/useTheme';
import { StyledButton } from '../styled';

const SavedPicksCloseButton: FC = () => {
  const { push } = useHistory();
  const isDark = useTheme();

  const handleClick = () => {
    push(ROUTE_DISCOVER);
  };

  return (
    <StyledButton aria-label="Back to discovery" onClick={handleClick}>
      <CrossLargeIcon color={isDark ? COLORS.white[100] : COLORS.black[100]} />
    </StyledButton>
  );
};

export default SavedPicksCloseButton;
